<template>
  <div class="customer-select-wrapper">
    <select-container
      :title="selectedServicesSummary?.title ?? 'בחירת שירותים'"
      :subtitle="selectedServicesSummary?.description ?? 'בחרו שירות אחד או יותר עבור התור'"
      icon="pi-sparkles"
      :img="selectedServices.length > 0 ? selectedServices.find(x => !!x.imageUrl)?.imageUrl : undefined"
      @click="containerClick" />
  </div>
</template>

<script lang="ts" setup>
import { computed, PropType, ref, watch } from 'vue';
import { IService } from '@torim-app/types';
import { SelectContainer, useDrawer } from '@torim-app/shared-components';
import SelectServiceDrawerContent from './SelectServiceDrawerContent.vue';

const props = defineProps({
  modelValue: {
    type: Object as PropType<IService[]>,
    required: true
  },
  selectedProvider: {
    type: String,
    required: false
  }
});

const emit = defineEmits(['servicesSelected']);
const { openDrawer, closeDrawer } = useDrawer();

const selectedServices = ref<IService[]>([...(props.modelValue ?? [])]);

watch(() => props.modelValue, (val) => {
  selectedServices.value = [...(val ?? [])];
});

const selectedServicesSummary = computed(() => {
  const formatLong = (text: string) => text.length > 40 ? text.slice(0, 40) + '...' : text;
  return {
    title: selectedServices.value.length > 0 ? `נבחרו ${selectedServices.value.length} שירותים` : undefined,
    description: selectedServices.value.length > 0 ? formatLong(selectedServices.value.map(s => s.name).join(', ')) : undefined
  };
});

const onServicesSelected = (services: IService[]) => {
  selectedServices.value = services;
  emit('servicesSelected', services);
};

const containerClick = () => {
  setTimeout(() => {
    openDrawer(SelectServiceDrawerContent, {
      selectedProvider: props.selectedProvider,
      initialServiceIds: selectedServices.value.map(s => s.id),
      onServicesSelected: onServicesSelected,
      onCancel: () => {
        closeDrawer();
      }
    }, {
      title: 'בחירת שירותים',
      noPadding: true
    });
  }, 300);
};
</script>

<style>
.customer-select-wrapper {
  width: 100%;
}
</style>
